export default "__VITE_ASSET__DLV6xuqc__"